var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicApi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09464 7.5H4.7413L2.91797 12.5H4.25714L4.6288 11.4783H6.20714L6.5788 12.5H7.91797L6.09464 7.5ZM4.93297 10.645L5.41797 9.31667L5.90297 10.6458L4.93297 10.645Z",
    fill: "#2A547C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2858 7.49997H9.36914V12.5H10.6191V10.8333H12.2858C12.4508 10.8364 12.6147 10.8061 12.7677 10.7444C12.9208 10.6826 13.0598 10.5907 13.1765 10.474C13.2932 10.3573 13.3851 10.2183 13.4469 10.0652C13.5086 9.9122 13.5389 9.74829 13.5358 9.5833V8.74997C13.5389 8.58497 13.5086 8.42106 13.4469 8.26802C13.3851 8.11499 13.2932 7.97597 13.1765 7.85928C13.0598 7.7426 12.9208 7.65063 12.7677 7.5889C12.6147 7.52716 12.4508 7.49691 12.2858 7.49997ZM12.2858 9.5833H10.6191V8.74997H12.2858V9.5833Z",
    fill: "#2A547C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H16.25V12.5H15V7.5Z",
    fill: "#2A547C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5.00016V15.0002H1.66667V5.00016H18.3333ZM18.3333 3.3335H1.66667C1.22464 3.3335 0.800716 3.50909 0.488155 3.82165C0.175595 4.13421 0 4.55814 0 5.00016L0 15.0002C0 15.4422 0.175595 15.8661 0.488155 16.1787C0.800716 16.4912 1.22464 16.6668 1.66667 16.6668H18.3333C18.7754 16.6668 19.1993 16.4912 19.5118 16.1787C19.8244 15.8661 20 15.4422 20 15.0002V5.00016C20 4.55814 19.8244 4.13421 19.5118 3.82165C19.1993 3.50909 18.7754 3.3335 18.3333 3.3335Z",
    fill: "#2A547C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#2A547C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicApi);
export default __webpack_public_path__ + "static/media/publicAPI.72088e39.svg";
export { ForwardRef as ReactComponent };